import { REQUEST_DATASET_REPROCESSING, RECIEVE_DATASET_REPROCESSING } from '../constants/actionTypes';
import { canReprocessScene } from './reprocessScene';
import { showReprocessingModal } from './modal';
import { getBody, generateReprocessingDialogText } from './helpers';
import { getBackendUrl } from '../env';


// Action Creators
const requestReprocessDataset = (scene, dataset) => ({
    type: REQUEST_DATASET_REPROCESSING,
    scene: scene,
    dataset: dataset
});

const recieveReprocessDataset = (scene, dataset) => ({
    type: RECIEVE_DATASET_REPROCESSING,
    scene: scene,
    dataset: dataset
});

// Action Logic
export const canReprocessDataset = (sceneMedia, dataset) => {
    // If the scene is reprocessing then so are the datasets, so the call is redundant
    if (!canReprocessScene(sceneMedia)) {
        return false;
    }

    // If there are datasets reprocessing, we can only reprocess it if the requested DS is not already pending
    if (sceneMedia.reprocessingDatasets && sceneMedia.reprocessingDatasets.length) {
        return sceneMedia.reprocessingDatasets.includes(dataset);
    }

    return true;
};

const reprocessDataset = (scene, dataset) => dispatch => {
    dispatch(requestReprocessDataset(scene, dataset));
    return fetch(`${getBackendUrl()}/api/v1/scene/${scene}/dataset/${dataset}`, {method: 'PUT'})
        .then(resp => getBody(resp, 301))
        .then(
            () => dispatch(recieveReprocessDataset(scene, dataset)),
            err => {
                dispatch(recieveReprocessDataset(scene, dataset));  // Promises should realy have a .finally()
                return err;
            }
        );
};

export const reprocessSelectedDatasetIfOK = scene => (dispatch, getState) => {
    const state = getState();
    const sceneMedia = state.mediaByScene[scene];

    // Get unique selected datasets
    const selectedDs = sceneMedia.mediaItems
        .filter(m => m.selected)
        .map(m => m.datasetNum);

    const uniqSelectedDs = Array.from(new Set(selectedDs));
    
    // Dispatch per each unique dataset
    const reprocessPromises = uniqSelectedDs.map(dsNum => canReprocessDataset(sceneMedia, dsNum) 
        ? dispatch(reprocessDataset(scene, dsNum))
        : Promise.resolve());
    
    // Generate and show the reprocessing dialog
    Promise.all(reprocessPromises)
        .then(results => generateReprocessingDialogText(results, 'datasets'))
        .then(text => dispatch(showReprocessingModal(text)));
};



// WEBPACK FOOTER //
// ./src/actions/reprocessDataset.js